var I = Object.defineProperty;
var O = (r, e, t) => e in r ? I(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var s = (r, e, t) => O(r, typeof e != "symbol" ? e + "" : e, t);
const i = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, d = {
  PROD: "https://accounts.credenza3.com",
  STAGING: "https://accounts.staging.credenza3.com",
  LOCAL: "http://localhost:8081"
};
function h(r) {
  switch (r.env) {
    case i.LOCAL:
      return d.LOCAL;
    case i.STAGING:
      return d.STAGING;
    case i.PROD:
      return d.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
const S = "credenza_web_sdk:";
function p(r, e) {
  return localStorage.setItem(`${S}${r}`, e);
}
function u(r) {
  return localStorage.getItem(`${S}${r}`);
}
function f(r = 16) {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let t = "";
  for (let n = 0; n < r; n++) {
    const a = Math.floor(Math.random() * e.length);
    t += e[a];
  }
  return t;
}
const L = {
  OAUTH: "oauth",
  METAMASK: "metamask",
  WALLET_CONNECT: "walletconnect"
};
class o extends Error {
}
o.prototype.name = "InvalidTokenError";
function P(r) {
  return decodeURIComponent(atob(r).replace(/(.)/g, (e, t) => {
    let n = t.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function y(r) {
  let e = r.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return P(e);
  } catch {
    return atob(e);
  }
}
function R(r, e) {
  if (typeof r != "string")
    throw new o("Invalid token specified: must be a string");
  e || (e = {});
  const t = e.header === !0 ? 0 : 1, n = r.split(".")[t];
  if (typeof n != "string")
    throw new o(`Invalid token specified: missing part #${t + 1}`);
  let a;
  try {
    a = y(n);
  } catch (c) {
    throw new o(`Invalid token specified: invalid base64 for part #${t + 1} (${c.message})`);
  }
  try {
    return JSON.parse(a);
  } catch (c) {
    throw new o(`Invalid token specified: invalid json for part #${t + 1} (${c.message})`);
  }
}
const g = "oauth:nonce", E = "oauth:state", _ = {
  CREDENTIALS: "credentials",
  PASSWORDLESS: "passwordless",
  GOOGLE: "google",
  TICKETMASTER: "ticketmaster"
}, l = {
  EMAIL: "email",
  PHONE: "phone"
};
async function v(r) {
  try {
    const e = await fetch(`${h(r)}/oauth2/revoke-session`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${r.getAccessToken()}`
      }
    });
    if (!e.ok) throw new Error(e.statusText);
  } catch (e) {
    throw new Error(`Error revoking session: ${e.message}`);
  }
}
class m {
  constructor() {
    s(this, "name", "oauth");
    s(this, "sdk");
  }
  async _initialize(e) {
    this.sdk = e, await this._handleRedirectResult();
  }
  async revokeSession() {
    if (!this.sdk.isLoggedIn()) throw new Error("Revoke failed: User is not logged in");
    return await v(this.sdk);
  }
  revokeBrowserSessionWithRedirect(e) {
    const t = new URL(h(this.sdk) + "/oauth2/logout");
    return t.searchParams.append("redirect_uri", e), window.location.href = t.toString();
  }
  // eslint-disable-next-line complexity
  login(e) {
    e.nonce || (e.nonce = f());
    const t = f(), n = new URL(h(this.sdk) + "/oauth2/authorize");
    n.searchParams.append("client_id", this.sdk.clientId), n.searchParams.append("response_type", "token"), n.searchParams.append("scope", e.scope), n.searchParams.append("redirect_uri", e.redirectUrl), n.searchParams.append("nonce", e.nonce), n.searchParams.append("state", t), n.searchParams.append("credenza_session_length_seconds", String(e.sessionLengthSeconds ?? 60 * 60)), e.type && (e.type !== _.CREDENTIALS && (n.pathname += `/${e.type}`), n.searchParams.append("allowed_login_types", e.type), e != null && e.passwordlessType && (n.searchParams.append("allowed_passwordless_login_type", e.passwordlessType), e.forceEmail && e.passwordlessType === l.EMAIL ? n.searchParams.append("force_email", e.forceEmail) : e.forcePhone && e.passwordlessType === l.PHONE && n.searchParams.append("force_phone", e.forcePhone))), p(g, e.nonce), p(E, t), window.location.href = n.toString();
  }
  async _handleRedirectResult() {
    const e = window.location.hash;
    if (!e) return;
    const t = e.replace("#", "").split("&").reduce((w, T) => {
      const [k, A] = T.split("=");
      return w[k] = A, w;
    }, {}), n = u(E);
    if (t.state !== n) throw new Error("Invalid state");
    if (!t.access_token) throw new Error("Invalid access token");
    const a = R(t.access_token);
    if (u(g) !== a.nonce) throw new Error("Invalid nonce");
    await this.sdk._setAccessToken(t.access_token, L.OAUTH), history && window.location.hash ? history.replaceState(null, document.title, window.location.pathname + window.location.search) : window.location.hash = "";
  }
}
s(m, "LOGIN_TYPE", _), s(m, "PASSWORDLESS_LOGIN_TYPE", l);
export {
  m as OAuthExtension
};
